export const partnerHomeMenu = [
  {
    lable: '诊所开通',
    children: [
      {
        lable: '绑定设备',
        icon: 'icon-bdsb',
        link: 'partnerBindDevice',
        color: '#527DFD'
      },
      {
        lable: '添加诊所',
        icon: 'icon-zs',
        link: 'partnerAddClinic',
        color: '#1DCDC2'
      },
      {
        lable: '解绑设备',
        icon: 'icon-jb',
        link: 'partnerDeviceList',
        color: '#FFCA19'
      },
      {
        lable: '我的诊所',
        icon: 'icon-wdzs',
        link: 'partnerMyClinic',
        color: '#7336F0'
      },
      {
        lable: '我的设备',
        icon: 'icon-wdsb',
        link: 'partnerDeviceList',
        color: '#fc752d'
      }
    ]
  },
  {
    lable: '业务员管理',
    children: [
      {
        lable: '添加业务员',
        icon: 'icon-tjywy',
        link: 'partnerInfoEditAdd',
        color: '#81e600'
      },
      {
        lable: '邀请业务员',
        icon: 'icon-yq',
        link: 'invite',
        color: '#10cc63'
      },
      {
        lable: '我的业务员',
        icon: 'icon-wdtd',
        link: 'partnerMyTeam',
        color: '#fa4f9b'
      },
      {
        lable: '二维码名片',
        icon: 'icon-ewm',
        link: 'qrcode',
        color: '#df20f8'
      }
    ]
  },
  {
    lable: '库存管理',
    children: [
      {
        lable: '申请设备',
        icon: 'icon-wz',
        link: 'partnerMaterialApplication',
        color: '#ff2d51'
      },
      {
        lable: '试剂出库',
        icon: 'icon-dck',
        link: 'partnerClinicOrderList',
        color: '#4ce1eb'
      },
      {
        lable: '设备库存',
        icon: 'icon-wdsb',
        link: 'partnerStockDeviceSales',
        color: '#8468fc'
      },
      {
        lable: '试剂库存',
        icon: 'icon-kcgl',
        link: 'partnerStockSales',
        color: '#faa014'
      },
      {
        lable: '设备申请记录',
        icon: 'icon-jl',
        link: 'partnerDeviceApplyRecord',
        color: '#fed343'
      }
    ]
  }
];

export const clinicHomeMenu = [
  {
    lable: '患者检测',
    children: [
      {
        lable: '申请检测',
        icon: 'icon-jc',
        link: 'clinicDetection',
        color: '#527DFD'
      },
      {
        lable: '扫描检测',
        icon: 'icon-sm',
        link: 'scanQRCode',
        color: '#1DCDC2'
      },
      {
        lable: '检测管理',
        icon: 'icon-jcgl',
        link: 'clinicDetectionManagement',
        color: '#FFCA19'
      }
    ]
  },
  {
    lable: '试剂采购',
    children: [
      {
        lable: '我要采购',
        icon: 'icon-cg',
        link: 'clinicBuy',
        color: '#81e600'
      },
      {
        lable: '我的订单',
        icon: 'icon-wddd',
        link: 'clinicMyOrder',
        color: '#10cc63'
      },
      {
        lable: '收货地址管理',
        icon: 'icon-sh',
        link: 'clinicMyAddress',
        color: '#fa4f9b'
      },
      {
        lable: '我的库存',
        icon: 'icon-kcgl',
        link: 'clinicInventory',
        color: '#df20f8'
      }
    ]
  },
  {
    lable: '我的诊所',
    children: [
      {
        lable: '诊所资料完善',
        icon: 'icon-wdzs',
        link: 'clinicInfoEdit',
        color: '#ff2d51'
      },
      {
        lable: '我的医生',
        icon: 'icon-ys',
        link: 'clinicMyDoctor',
        color: '#4ce1eb'
      },
      {
        lable: '添加医生',
        icon: 'icon-yq',
        link: 'clinicAddDoctor',
        color: '#8468fc'
      },
      {
        lable: '我的设备',
        icon: 'icon-wdsb',
        link: 'clinicMyDevice',
        color: '#faa014'
      }
    ]
  }
];
